// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-core-components-SearchSelect-style__wrapper_ZGyND","searchIcon":"src-modules-core-components-SearchSelect-style__searchIcon_CBAS+"};